import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useLoginForm, LoginFormValues } from "@/hooks/useLoginForm";
import { useLoginAuth } from "@/hooks/useLoginAuth";

export const LoginForm = () => {
  const { t } = useTranslation(["auth", "common"]);
  const form = useLoginForm();
  const { isLoading, handleLogin } = useLoginAuth();

  const onSubmit = async (values: LoginFormValues) => {
    await handleLogin(values.email, values.password);
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("email", { ns: "auth" })}</FormLabel>
              <FormControl>
                <Input
                  placeholder="you@example.com"
                  {...field}
                  autoComplete="email"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("password", { ns: "auth" })}</FormLabel>
              <FormControl>
                <Input
                  type="password"
                  placeholder="••••••"
                  {...field}
                  autoComplete="current-password"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="text-right text-sm">
          <Link
            to="/forgot-password"
            className="text-amber-600 hover:underline font-medium"
          >
            {t("forgotPassword", { ns: "auth" })}
          </Link>
        </div>

        <Button
          type="submit"
          className="w-full bg-amber-500 hover:bg-amber-600"
          disabled={isLoading}
        >
          {isLoading ? t("loading", { ns: "common" }) : t("login", { ns: "auth" })}
        </Button>
      </form>
    </Form>
  );
};
